import unionAxios from "@/utils/union-axios";
//首页查询个人/队伍打榜排名信息
export const winningRecord = (param) => {
  return unionAxios.post(`/web-h5/charge/rankingActivity/winningRecord`, param);
};
